export const B3MO_ICON_SRC = "/b3mo.png";
export const B3MO_ICON_CLASS = "h-6 w-6 object-contain flex-shrink-0 mt-0.5";

const B3MO_SUBTITLES = {
  b3mo_challenge_escrow_deposit: "Challenge Deposit",
  b3mo_challenge_principal_return: "Principal Return",
  b3mo_challenge_payout_reward: "Challenge Reward",
  b3mo_split_win_reward: "SplitWin Reward",
};

export function isB3moClass(classification) {
  return String(classification || "")
    .trim()
    .toLowerCase()
    .startsWith("b3mo_");
}

export function isB3moTransaction(tx = {}, classification = "") {
  if (isB3moClass(classification || tx.classification || tx.type)) return true;

  const kind = String(tx.x2earnRewardKind || "").trim().toLowerCase();
  if (kind === "b3mo_quest") return true;

  const incomeSource = String(tx.incomeSource || "").trim().toLowerCase();
  if (incomeSource === "b3mo_quest_payout") return true;

  const sub = String(tx.subApplication || "").trim().toLowerCase();
  if (sub.includes("b3mo")) return true;

  return false;
}

export function getB3moDisplay(classification, tx = null) {
  const cls = String(classification || "")
    .trim()
    .toLowerCase();

  if (B3MO_SUBTITLES[cls]) {
    return {
      title: "B3MO",
      subtitle: B3MO_SUBTITLES[cls],
    };
  }

  if (tx && isB3moTransaction(tx, cls)) {
    return {
      title: "B3MO",
      subtitle: "Quest Reward",
    };
  }

  return null;
}
